<section [class.display-column-flex]="compact" [class.flex-1]="compact">
  <p class="text-small text-uppercase bold color--dark-blue-grey lineheight--condensed mb--sm" [class.mt--none]="compact">
    {{ (usePayoutTerminology
      ? 'App.Admin.Dashboard.Commission.PayoutTitle'
      : 'App.Admin.Dashboard.Commission.Title') | translate }}
  </p>

  @if (isLoading) {
    <div class="display-flex justify-content-center my--xl">
      <mat-spinner class="primary-spinner"></mat-spinner>
    </div>
  } @else if (report) {
    <app-report-data-warning
      [comparisonPeriod]="report.comparisonPeriod"
      [dataSince]="report.dataSince"
      [selectedRange]="selectedRange">
    </app-report-data-warning>

    @if (hasData) {
      <mat-card class="commission-overview" [class.flex-1]="compact">
        <div class="commission-overview__content" [class.commission-overview__content--compact]="compact">
          <div class="commission-overview__total">
            <mat-card-header>
              <mat-card-title>
                {{ (usePayoutTerminology
                  ? 'App.Admin.Dashboard.Commission.EstimatedPayouts'
                  : 'App.Admin.Dashboard.Commission.EstimatedCommission') | translate }}
              </mat-card-title>
              <mat-card-subtitle>
                {{ 'App.Admin.Dashboard.Commission.PreTax' | translate }}
                {{ report.totals.preTax | currency:'CAD':'symbol-narrow':'1.2-2' }}
                &middot;
                {{ 'App.Admin.Dashboard.Commission.Tax' | translate }}
                {{ report.totals.tax | currency:'CAD':'symbol-narrow':'1.2-2' }}
              </mat-card-subtitle>
            </mat-card-header>
            <mat-card-content>
              <div>
                <p class="commission-overview__value bold color--navy lineheight--none mt--none mb--xs">
                  {{ report.totals.postTax.value | currency:'CAD':'symbol-narrow':'1.2-2' }}
                </p>
                <app-comparison-badge
                  [value]="comparisonValue"
                  [digits]="hasPercent ? 1 : 2"
                  [prefix]="hasPercent ? '' : '$'"
                  [suffix]="hasPercent ? '%' : ''">
                </app-comparison-badge>
              </div>
            </mat-card-content>
          </div>

          <div class="commission-overview__sources">
            <mat-card-header>
              <mat-card-title>
                {{ (usePayoutTerminology
                  ? 'App.Admin.Dashboard.Commission.PayoutsBySource'
                  : 'App.Admin.Dashboard.Commission.BySource') | translate }}
              </mat-card-title>
              <mat-card-subtitle>{{ 'App.Admin.Dashboard.Commission.SourceSubtitle' | translate }}</mat-card-subtitle>
            </mat-card-header>
            <mat-card-content>
              <div class="commission-sources">
                @for (source of sourceRows; track source.key) {
                  <div class="commission-source commission-source--{{ source.key }}">
                    <span>{{ source.label | translate }}</span>
                    <span class="commission-source__track bg--lighter-grey">
                      <span class="commission-source__fill display-block h-100" [style.width.%]="source.width"></span>
                    </span>
                    <strong>{{ source.value | currency:'CAD':'symbol-narrow':'1.2-2' }}</strong>
                  </div>
                }
              </div>
            </mat-card-content>
          </div>
        </div>
      </mat-card>

      @if (showLocations && locations.length) {
        <mat-card class="mt--md">
          <mat-card-header>
            <mat-card-title>
              {{ (usePayoutTerminology
                ? 'App.Admin.Dashboard.Commission.PayoutsByLocation'
                : 'App.Admin.Dashboard.Commission.ByLocation') | translate }}
            </mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <app-commission-estimate-table
              [locations]="locations"
              [usePayoutTerminology]="usePayoutTerminology">
            </app-commission-estimate-table>
          </mat-card-content>
        </mat-card>
      }
    } @else {
      <mat-card [class.flex-1]="compact">
        <mat-card-content class="display-flex justify-content-center py--lg">
          <app-no-data
            [message]="(usePayoutTerminology
              ? (report.dataSince
                ? 'App.Admin.Dashboard.Commission.NoPayouts'
                : 'App.Admin.Dashboard.Commission.NoPayoutReportingData')
              : (report.dataSince
                ? 'App.Admin.Dashboard.Commission.NoCommission'
                : 'App.Admin.Dashboard.Commission.NoReportingData')) | translate">
          </app-no-data>
        </mat-card-content>
      </mat-card>
    }
  }
</section>
